// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_df-2";
export var aiChatCartContainerExit = "_df-4";
export var aiChatContainerLarge = "_df-0";
export var aiChatContainerSmall = "_df-1";
export var aiChatIcon = "_df-6";
export var slideInFromRight = "_df-3";
export var slideOutToRight = "_df-5";